import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './carousel-article-small-item.component.scss';
var CarouselArticleSmallItem = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselArticleSmallItem, _super);
    function CarouselArticleSmallItem(element) {
        return _super.call(this, element) || this;
    }
    CarouselArticleSmallItem.prototype.init = function () { };
    ;
    CarouselArticleSmallItem.prototype.bindEvents = function () { };
    ;
    return CarouselArticleSmallItem;
}(Base));
export { CarouselArticleSmallItem };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-small-item/carousel-article-small-item.component.ts
// module id = 189
// module chunks = 0